import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Games from '@/components/Games'
import Results from '@/components/Results'
import About from '@/components/About'
import Help from '@/components/Help'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/games/:game',
      name: 'Games',
      component: Games
    },
    {
      path: '/results/:game',
      name: 'Results',
      component: Results
    },
    {
      path: '/about/:page',
      name: 'About',
      component: About
    },
    {
      path: '/help/:page',
      name: 'Help',
      component: Help
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js